import { Page } from '@/domain/models/page/page'
import { TenantId } from '@/domain/models/tenant/tenant-id'
import { getTenantConfigsByPage } from '@/data/use-cases/tenant/get-tenant-configs'
import { PossiblePageTenantConfigs } from '@/domain/models/tenant/tenant-configs'

export const useTenantConfigs = (tenantId: TenantId, page: Page): PossiblePageTenantConfigs => getTenantConfigsByPage(tenantId, page)
